import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferInformationComponent } from '@components/TransferInformation/TransferInformation.component';
import { environment } from '@environments/environment';
import { FollowStoryUpdateEvent } from '@models/ncx/followers';
import { Stories } from '@models/ncx/story';
import { IFunctionAbility, User } from '@models/users';
import { AuthService } from '@services/auth/auth.service';
import { BreakpointService } from '@services/breakpoint.service';
import { ClipboardService } from '@services/clipboard.service';
import { CommonService } from '@services/common-service';
import { NavigationService } from '@services/navigation-service';
import { ToastService } from '@services/toastService/toastMessage.service';
import { WebSocketService } from '@services/websocket.service';
import { Common } from '@utilities/common';
import { Time } from '@utilities/time';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-detail-story',
  templateUrl: './detail-story.component.html',
  styleUrls: ['./detail-story.component.scss']
})
export class DetailStoryComponent implements OnInit, AfterViewChecked, OnDestroy, OnChanges {

  getApiURL: string;

  isMergeStoryVisible = false;

  mergedStory = false;

  followerApi: string;

  customPopOver: boolean;

  showpop: boolean;

  profileInDescription: User = {} as User;

  userInfoDetails: any;

  visible = false;

  isCollapsed = true;

  storyId;

  story;

  isLoaded = false;

  isTokenReplaced = false;

  @Input() storyDetails = null as Stories;

  slugDetails = null;

  isinfocenterVisible = false;

  topics = '';

  storyTags = '';

  postTags = '';

  showPostTagsToolTip: boolean = false;

  postTagsTooltipTrigger = 'manual';

  draftMessage = 'This document is a draft and will not be visible to others until you Publish it.';

  storyTitle = 'Example title for a story that would extend past here and would keep going to the edge of blah, blah, blah';

  storyDescription = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ornare massa at nunc egestas bibendum. Suspendisse potenti. Donec tristique dolor mi, quis porttitor sem auctor eget. In magna ipsum, euismod sed bibendum nec, consectetur quis elit. Vivamus pulvinar eu purus eget mattis. Praesent vulputate rhoncus erat in fringilla. Aliquam ultricies libero elit, ac congue nisl hendrerit luctus. Praesent non odio eu tellus consectetur porta. Pellentesque et dui scelerisque, tristique erat nec, sagittis massa. Nam vel sollicitudin est. Phasellus in tortor consequat, vulputate nibh ut, pretium orci. Vivamus efficitur quam odio, nec eleifend ante euismod sed. Aenean auctor mattis blandit. Sed facilisis justo vel urna mollis, id molestie diam mollis. Vivamus iaculis pharetra urna, ut pellentesque augue. Praesent vitae tristique arcu. Fusce tellus nisl, ultricies in ultrices vel, porta at orci. Aenean facilisis leo pretium sapien tincidunt, nec euismod lacus dapibus. Maecenas egestas est sit amet hendrerit malesuada.';

  slackUrl = environment.slackUrl;

  public functionAbility = {} as IFunctionAbility;

  subscriptionsWs: Subscription = new Subscription();

  breakPointSubscription: Subscription = new Subscription();

  routerSubscription: Subscription = new Subscription();

  @ViewChild('storyDetailsContent') storyDetailsContent: ElementRef;

  @ViewChild('standardguidance') standardGuidance: ElementRef;

  constructor(
    private router: ActivatedRoute,
    private cService: CommonService,
    private authService: AuthService,
    private reRoute: Router,
    private toastService: ToastService,
    private navigationService: NavigationService,
    private tI: TransferInformationComponent,
    private titleService: Title,
    private breakpointService: BreakpointService,
    private clipboardService: ClipboardService,
    private wS: WebSocketService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.getApiURL = environment.getStoriesAPI;
    this.followerApi = environment.storyFollower;

    // if (this.storyDetails) {
    //   this.bindStory(this.storyDetails);
    // }
    // else {
    //   this.routerSubscription = this.router.params.subscribe(
    //     (params: Params) => {

    //       const id = params.storyId;

    //       this.storyId = id.substr(1);
    //       this.getStory(this.storyId);

    //     });
    // }
    this.functionAbility = { ...this.tI.userFunctionAbility } as IFunctionAbility;
    this.userInfoDetails = {
      userId: this.tI.userInfoDetails.userId,
      role: this.tI.userInfoDetails.role
    };

    // Close the right-hand drawer if the browser is minimized to handset and the drawer is open
    this.breakPointSubscription = this.breakpointService.isMobile.subscribe((isMobile: boolean) => {

      if (isMobile && !this.isCollapsed) {

        this.isCollapsed = true;

      }

    });

    //After the story is merged the page will be redirected to Story-Landing. Web Scoket update need not to be executed.
    this.subscriptionsWs = this.wS.doSocketData$.subscribe((data) => {

      if (!this.mergedStory) {

        console.log('Web socket notification received. Calling refreshStoryDetails event in view story');
        this.refreshStoryDetails(data);

      }

    });

  }

  ngOnChanges(changes: any) {

    if (changes.storyDetails && changes.storyDetails.currentValue) {

      this.bindStory(this.storyDetails);

    }

  }

  ngAfterViewChecked() {

    this.changeDetector.detectChanges();

  }

  open(): void {

    this.visible = !this.visible;

  }

  toggleSider(): void {

    this.isCollapsed = !this.isCollapsed;

  }

  closeSlider(): boolean {

    this.isCollapsed = !this.isCollapsed;
    return this.isCollapsed;

  }

  isEdit(_event: any): void {

    this.reRoute.navigate(['ncx/create-story/:' + this.storyId]);

  }

  viewMergeStory() {

    this.isMergeStoryVisible = true;

  }

  openInfoCenter() {

    this.isinfocenterVisible = true;

  }

  openFollowers(storyId) {

    this.reRoute.navigate(['ncx/following/:' + storyId]);

  }

  closeMergeStory() {

    this.isMergeStoryVisible = false;
    this.mergedStory = true;

  }

  closeInfoCenter() {

    this.isinfocenterVisible = false;

  }

  utcToLocal(apiDate, type) {

    if (type === 'DATE') {

      return Time.convertingUtcToLocalDate(apiDate);

    } else {

      return Time.convertingUtcToLocalTime(apiDate);

    }

  }

  bindStoryDetails(res) {

    if (res && res.isDeleted) {

      this.toastService.createMessage('error', 'Requested Story does not exist. Redirecting to stories dashboard.');

      setTimeout(() => {

        this.reRoute.navigate(['ncx/stories-dashboard']);

      }, 500);

      return;

    }

    if ((res && res.storyAccess === 'private') && !(((res.createUser && res.createUser.userId === Number(localStorage.getItem('userId')))
      || (this.functionAbility.fa_access_private_story)))) {

      this.toastService.createMessage('error', 'You dont have access to the story');
      setTimeout(() => {

        this.reRoute.navigate(['ncx/stories-dashboard']);

      }, 500);
      return;

    }

  }

  updateFollower(status: FollowStoryUpdateEvent) {

    this.storyDetails.isUserFollowing = status.type;
    this.storyDetails.storyFollowerCount = status.data.storyFollowerCount;

  }

  getStory(storyId) {

    this.isLoaded = false;

    const queryStr = `/${storyId}`;

    this.cService.serviceRequestCommon('get', this.getApiURL, queryStr).subscribe((res: any) => {

      this.bindStory(res);
      this.bindStoryDetails(res);

    }, err => {

      if (err.error.errorCode === 'STORY-003') {

        this.toastService.createMessage('error', `You don't have access to the story. Redirecting to stories dashboard.`);
        setTimeout(() => {

          this.reRoute.navigate(['ncx/stories-dashboard']);

        }, 500);

      } else {

        this.toastService.createMessage('error', err);

      }

    }).add(() => {

      this.isLoaded = true;

    });

  }

  bindStory(res) {

    this.storyDetails = res;

    this.storyDetails.storyState = this.storyDetails.storyState.toLowerCase();

    //this.storyDetails.autoGeneratedStoryId = 'HardCoded - SA47FL0001';

    this.titleService.setTitle(res.storyTitle);

    setTimeout(() => {

      if (!Common.isInputHasValidTextContent(this.storyDetails.storyContent)) {

        this.storyDetails.storyContent = '';

      } else {

        this.storyDetails.storyContent = this.authService.addJWTTokenToLink(this.storyDetails.storyContent, 'img');

      } //JWT Token has to be added to the
      // img S3 link to download the file from S3

      /**
       * .fr-deletable class added to the description if a profile is added to the froala editor - @username
       */
      const part = this.storyDetailsContent?.nativeElement?.querySelectorAll('.fr-deletable');

      part.forEach((anchor: HTMLAnchorElement) => {

        anchor.addEventListener('mouseenter', this.handleAnchorClick.bind(this));
        anchor.addEventListener('click', this.handleAnchorClick.bind(this));

      });

    }, 500);

    //this.topics = this.storyDetails.topicsInObjectFormat.reduce((displayTopics, topic) => displayTopics + ',' + ' #' + topic.topicName.toString());

    this.topics = this.storyDetails.topicDetails?.map(topic => topic.topicName.toString()).join(', ');

    //  res.topics && Object.keys(res.topics).length ? Object.values(res.topics).join(',') : '';
    this.storyTags = Array.isArray(res.storyContentTags) ? res.storyContentTags.join(', ') : '';

    this.postTags = Array.isArray(res.postContentTags) ? res.postContentTags.join(', ') : '';

    this.slugDetails = this.storyDetails.storySlug;
    this.storyTitle = this.storyDetails.storyTitle;

    this.navigationService.overridePageTitle(this.storyTitle);

    if (this.slugDetails === null) {

      this.slugDetails = {
        who: '',
        what: '',
        where: '',
        when: ''
      };

    }

    if (!this.breakpointService.isMobile.value) {

      this.isCollapsed = false;

    }

    //this.bindStoryDetails(res);

    this.isLoaded = true;

  }

  /**
   *
   * Listens for click events on HTML content in Story Description
   */
  handleAnchorClick(event) {

    this.customPopOver = false;
    this.showpop = true;
    if (event && event.srcElement && event.srcElement.id && event.srcElement.id.startsWith('user-')) {

      const userId = event.srcElement.id.split('-')[1];

      this.profileInDescription.userId = userId;

    } else {

      return;

    }
    setTimeout(() => {

      const element: HTMLElement = document.getElementById('triggerClick') as HTMLElement;

      element.style.left = (event.layerX + 25) + 'px';
      element.style.top = (event.layerY + 110) + 'px';
      this.customPopOver = true;

      element.click();

    });

  }

  deleteStory(event: any) {

    if (event === 'true') {

      this.isLoaded = false;

      const queryStr = `/${this.storyId}`;

      this.cService.serviceRequestCommon('delete', this.getApiURL, queryStr).subscribe((val) => {

        if (val === null) {

          this.toastService.createMessage('success', 'The story has been successfully deleted.', { nzDuration: 5000 });
          setTimeout(() => {

            this.reRoute.navigate(['ncx/stories-dashboard']);

          }, 5000);

        }

      },
        () => {

          this.toastService.createMessage('error', 'Error while deleting the story. Please try again.');

        }).add(() => {

          this.isLoaded = true;

        });

    }

  }

  get isMobile(): boolean {

    return this.breakpointService.isMobile.value;

  }

  get isXSmall(): boolean {

    return this.breakpointService.breakpoints.value['xsmall'];

  }

  get name(): string {

    return Common.formatName(this.storyDetails.createUser);

  }

  refreshStoryDetails(data) {

    if (data.story && data.story.storyId == this.storyId && data.story.isDeleted == false) {

      this.bindStory(data.story);
      this.bindStoryDetails(data.story);

    } else if (data.story && data.story.storyId == this.storyId && data.story.isDeleted == true) {

      this.reRoute.navigate(['ncx/stories-dashboard']);

    }

  }

  copyStoryIdInClipboard($event) {

    this.clipboardService.copyToClipboard($event);

    this.toastService.createMessage('success', 'ID copied to clipboard');

  }

  ngOnDestroy(): void {

    this.subscriptionsWs.unsubscribe();
    this.breakPointSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();

  }


  /**
   * Toggles the visibility of the subject tooltip on mobile devices.
   * 
   * This method checks if the current device is a mobile device by evaluating the `isMobile` property.
   * If it is a mobile device, it toggles the `showSubjectToolTip` property, which controls the visibility
   * of the subject tooltip.
   */
  togglePostTagsTooltip() {

    if (this.isMobile) {

      this.showPostTagsToolTip = !this.showPostTagsToolTip;

    }

  }

  /**
   * Displays the subject tooltip with a delay if the application is not running on a mobile device
   * and the tooltip is not already shown.
   *
   * This method sets a timeout of 500 milliseconds before showing the tooltip.
   */
  showPostTagsTooltipEvent() {

    if (!this.isMobile && !this.showPostTagsToolTip) {

      setTimeout(() => {

        this.showPostTagsToolTip = true;

      }, 500);

    }

  }

  /**
   * Hides the subject tooltip after a delay if the current device is not mobile and the tooltip is currently shown.
   * 
   * @remarks
   * This method uses a timeout to delay the hiding of the tooltip by 500 milliseconds.
   * 
   * @returns {void}
   */
  hidePostTagsTooltip() {

    if (!this.isMobile && this.showPostTagsToolTip) {

      setTimeout(() => {

        this.showPostTagsToolTip = false;

      }, 500);

    }

  }

}
